import { getDisplayChannelsIds } from 'gcs-common/slices/channelList/channelListSelectors/getDisplayChannelsIds';
import { useSelector } from 'react-redux';
import ChannelListItemCollapsed from '../../ChannelListItemCollapsed/ChannelListItemCollapsed';
import styles from './styles.module.scss';

function AgentChannelListCollapsed() {
  const displayChannelIds: string[] = useSelector(getDisplayChannelsIds);
  return (
    <div className={styles.channelList}>
      {displayChannelIds.map((channelId) => (
        <ChannelListItemCollapsed channelId={channelId} key={channelId} />
      ))}
    </div>
  );
}

export default AgentChannelListCollapsed;
